<div class="planning-grid">

  <app-scrollable class="planning-grid__scroll" axis="both">
    <table class="planning-grid__table" role="grid" [attr.aria-label]="'PLANNING.DRILLING' | translate">

      <thead>
        <tr>
          <th class="planning-grid__sticky-left planning-grid__corner" rowspan="2" scope="col">
            <app-input
              class="planning-grid__search"
              type="search"
              [placeholder]="'GLOBAL.RECHERCHER' | translate"
              [clearable]="true"
              [ngModel]="searchTerm()"
              (ngModelChange)="searchTerm.set($event)"
              data-attr="area-planning-drilling-search">
              <img slot="icon-left" src="assets/icon/new_icon/search.svg" alt="" />
            </app-input>
          </th>

          @for (group of dayGroups(); track group.date) {
            <th
              class="planning-grid__day"
              [attr.colspan]="group.shiftCount"
              [class.is-today]="group.isToday"
              [style.min-width.px]="cellWidthPx() * group.shiftCount"
              scope="colgroup">
              <span class="planning-grid__weekday">{{ group.weekday }}</span>
              <span class="planning-grid__day-number">{{ group.dayNumber }}</span>
            </th>
          }

          <th class="planning-grid__sticky-right planning-grid__totals-head" rowspan="2" scope="col">
            {{ 'PLANNING.TOTALS' | translate }}
          </th>
        </tr>

        <tr>
          @for (col of shiftColumns(); track col.id) {
            <th
              class="planning-grid__shift"
              [class.is-day-start]="col.shiftIndex === 0"
              [class.is-day-shift]="col.kind === 'day'"
              [class.is-today]="col.isToday"
              [style.width.px]="cellWidthPx()"
              [style.min-width.px]="cellWidthPx()"
              [title]="col.shiftLabel"
              scope="col">
              <app-shift-icon [kind]="col.kind" />
            </th>
          }
        </tr>
      </thead>

      <tbody>
        @for (blast of visibleBlasts(); track blast.blastId) {
          @let totals = getTotals(blast);
          <tr>
            <td class="planning-grid__sticky-left planning-grid__label" [title]="blast.zone" (click)="blastClick.emit(blast)">
              <div class="planning-grid__name">{{ blast.label }}</div>
              <div class="planning-grid__meta">
                {{ 'PLANNING.HOLES_TARGET' | translate: { holes: blast.holeCount, meters: blast.targetMeters } }}
              </div>
            </td>

            @for (col of shiftColumns(); track col.id) {
              <td
                class="planning-grid__cell"
                [class.is-day-start]="col.shiftIndex === 0"
                [class.is-day-shift]="col.kind === 'day'"
                [class.is-today]="col.isToday"
                [style.width.px]="cellWidthPx()">
                <app-activity-cell
                  [items]="getItemsForCell(blast, col)"
                  [activeId]="activeId()"
                  [isBlastDate]="isBlastDateCell(blast, col)"
                  (itemClick)="openCard($event)" />
              </td>
            }

            <td class="planning-grid__sticky-right planning-grid__totals">
              <div
                class="planning-grid__progress-track"
                role="progressbar"
                [attr.aria-valuenow]="clamp100(totals.progress)"
                aria-valuemin="0"
                aria-valuemax="100">
                <div class="planning-grid__progress-fill" [style.width.%]="clamp100(totals.progress)"></div>
              </div>
              <div class="planning-grid__totals-numbers">
                <span class="planning-grid__percent">{{ totals.progress.toFixed(0) }}%</span>
                <span class="planning-grid__ratio">{{ totals.realized }}m/{{ blast.targetMeters }}m</span>
              </div>
            </td>
          </tr>
        }

        <tr class="planning-grid__filler" aria-hidden="true">
          <td class="planning-grid__sticky-left"></td>
          @for (col of shiftColumns(); track col.id) {
            <td
              class="planning-grid__cell"
              [class.is-day-start]="col.shiftIndex === 0"
              [class.is-day-shift]="col.kind === 'day'"
              [class.is-today]="col.isToday"></td>
          }
          <td class="planning-grid__sticky-right"></td>
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <td class="planning-grid__sticky-left planning-grid__footer-label">
            {{ 'PLANNING.COMPLETED' | translate }}
          </td>

          @for (col of shiftColumns(); track col.id) {
            @let shiftTotal = getShiftTotal(col);
            <td class="planning-grid__footer-cell">
              {{ shiftTotal > 0 ? shiftTotal + 'm' : '-' }}
            </td>
          }

          <td class="planning-grid__sticky-right planning-grid__footer-total">
            @let summary = overall();
            <div class="planning-grid__footer-summary">
              <app-progress-ring [percent]="summary.percent" />
              <div>
                <span class="planning-grid__footer-percent">{{ summary.percent.toFixed(0) }}%</span>
                <span class="planning-grid__footer-ratio">{{ summary.realized }}m/{{ summary.target }}m</span>
              </div>
            </div>
          </td>
        </tr>
      </tfoot>

    </table>
  </app-scrollable>

</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="cardAnchor() ?? el.nativeElement"
  [cdkConnectedOverlayOpen]="!!activeSession()"
  [cdkConnectedOverlayPositions]="cardPositions"
  (overlayOutsideClick)="closeCard()"
  (detach)="closeCard()">
  <app-activity-card
    [title]="'PLANNING.DRILLING_SESSION' | translate"
    [fields]="cardFields()"
    (seeMore)="onSeeMore()"
    (closed)="closeCard()" />
</ng-template>
